import { useTranslate } from "ra-core";
import { BooleanInput } from "@/components/admin/boolean-input";
import { DateInput } from "@/components/admin/date-input";
import { NumberInput } from "@/components/admin/number-input";
import { SelectInput } from "@/components/admin/select-input";
import { TextInput } from "@/components/admin/text-input";
import { getOriginChannels } from "@/lib/originChannels";
import { isNaiuTenant } from "@/lib/tenant";

const PRODUCT_LINES = [
  { value: "vital", label: "NAIU Vital" },
  { value: "fungi", label: "NAIU Fungi" },
  { value: "both", label: "Las dos" },
];

const HEALTH_GOALS = [
  { value: "energia", label: "Energía" },
  { value: "enfoque", label: "Enfoque" },
  { value: "inmune", label: "Sistema inmune" },
  { value: "rendimiento", label: "Rendimiento" },
  { value: "otro", label: "Otro" },
];

export function NaiuContactFields() {
  const translate = useTranslate();
  if (!isNaiuTenant()) {
    return null;
  }

  return (
    <div className="flex flex-col gap-4">
      <h6 className="text-lg font-semibold">
        {translate("resources.contacts.field_categories.catalog", {
          _: "Catálogo y recompra",
        })}
      </h6>
      <SelectInput
        source="origin"
        choices={getOriginChannels()}
        optionText="label"
        optionValue="value"
        label={translate("resources.contacts.fields.origin", {
          _: "De dónde llegó",
        })}
        helperText={false}
      />
      <SelectInput
        source="product_line"
        choices={PRODUCT_LINES}
        optionText="label"
        optionValue="value"
        label={translate("resources.contacts.fields.product_line", {
          _: "Línea",
        })}
        helperText={false}
      />
      <TextInput
        source="products"
        label={translate("resources.contacts.fields.products", {
          _: "Productos comprados",
        })}
        helperText={translate("resources.contacts.fields.products_help", {
          _: "Por ejemplo: maca roja, melena de león, cacao.",
        })}
      />
      <SelectInput
        source="health_goal"
        choices={HEALTH_GOALS}
        optionText="label"
        optionValue="value"
        label={translate("resources.contacts.fields.health_goal", {
          _: "Objetivo",
        })}
        helperText={false}
      />
      <DateInput
        source="last_purchase_date"
        label={translate("resources.contacts.fields.last_purchase_date", {
          _: "Última compra",
        })}
        helperText={false}
      />
      <NumberInput
        source="repurchase_days"
        label={translate("resources.contacts.fields.repurchase_days", {
          _: "Recompra cada (días)",
        })}
        helperText={translate(
          "resources.contacts.fields.repurchase_days_help",
          {
            _: "Depende del producto. Cuando se pase ese ciclo, mueve el negocio a Por recomprar.",
          },
        )}
      />
      <NumberInput
        source="lifetime_value"
        label={translate("resources.contacts.fields.lifetime_value", {
          _: "Total comprado (COP)",
        })}
        helperText={false}
      />
      <BooleanInput
        source="has_newsletter"
        label={translate("resources.contacts.fields.marketing_consent", {
          _: "Acepta que le escriban",
        })}
        helperText={false}
      />
    </div>
  );
}
